module.exports = __webpack_public_path__ + "static/media/rhy.9295e342.png";